import { Box, Divider, Typography } from "@mui/material";
import palette from "../../../theme/palette";
import { IInvoice } from "../../../types/commonTypes";
import { makeTransactionItems } from "../../../helpers/data";
import ViewInvoicesLinks from "../view-invoices-links/ViewInvoicesLinks";
import "./transactionDetailsTabContent.scss";

interface ITransactionDetailTabContentProps {
	subtotal: string;
	taxes: string;
	flatFees: string;
	discount: string;
	total: string;
	paidAmount: string;
	invoices: IInvoice[];
}

const TransactionDetailsTabContent: React.FC<ITransactionDetailTabContentProps> = (props) => {
	const { subtotal, taxes, flatFees, discount, total, paidAmount, invoices } = props;
	const transactionItems = makeTransactionItems(
		subtotal,
		taxes,
		flatFees,
		discount,
		total,
		paidAmount,
	);

	return (
		<>
			<Box
				className="transaction_detail_hold"
				sx={{
					paddingBlock: "16px",
					background: palette.grey[0],
					borderRadius: "8px",
					"@media (min-width: 1024px)": {
						paddingBlock: "0px",
					},
				}}
			>
				{Object.keys(transactionItems).map((key, index) => {
					const item = transactionItems[key];
					const isPaymentAmount = key === "paid_amount_hold";
					if (!item) return null;

					const itemNumber = index + 1;

					if (item.isInvoices) {
						return (
							<Box
								key={key}
								className={`${key} item item_${itemNumber} index_${index} ${item.additionalClass}`}
							>
								<Typography className="title" variant="body1">
									{item.title}
								</Typography>
								{invoices?.length > 0 && <ViewInvoicesLinks invoices={invoices} />}
							</Box>
						);
					}

					return (
						<Box key={key}>
							{isPaymentAmount ? <Divider className="divider" /> : null}
							<Box className={`${key} item item_${itemNumber} index_${index} ${item.additionalClass}`}>
								<Typography className="title" variant="body1">
									{item.title}
								</Typography>
								<Typography className="value" variant="body1">
									{item.value}
								</Typography>
							</Box>
							{isPaymentAmount ? <Divider className="divider" /> : null}
						</Box>
					);
				})}
			</Box>
		</>
	);
};
export default TransactionDetailsTabContent;
